import classNames from "classnames";
import { RoundedCard, RoundedCardProps } from "../RoundedCard/RoundedCard";

const yearsBetweenDates = (startDate: Date, endDate: Date, selectedDate: Date | null) => {
  const selectedDateYear = selectedDate?.getFullYear();
  const startDateYear = startDate.getFullYear();
  const startYear = selectedDateYear && selectedDateYear < startDateYear ? selectedDateYear : startDateYear;
  const endYear = endDate.getFullYear();
  const yearsBetween = endYear - startYear + 1;

  return new Array(yearsBetween).fill(startYear).map((val, i) => val + i);
};

const weekDayMap: Record<string, string> = {
  Monday: "M",
  Tuesday: "T",
  Wednesday: "W",
  Thursday: "T",
  Friday: "F",
  Saturday: "S",
  Sunday: "S",
};

const Container = ({ className, ...props }: RoundedCardProps) => <RoundedCard {...props} className={classNames("!p-0", className)} />;

export { yearsBetweenDates, weekDayMap, Container };
